export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_07.891f50a2.jpg";